import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ConfirmPutAwayForm from '../../../PutAway/ConfirmPutAway/index';
import UploadGRN from '../../../PutAway/UploadGRN/index';
import PrintDetailForm from '../../../PutAway/PrintDetail/index';
import PrintPutAwayForm from '../../../PutAway/PrintPutAway/index.jsx';
import AllocatePutAway from '../../../PutAway/AllocatePutAway/index';



export default () => (
  <Switch>
    <Route path="/putaway/confirmputawayform" component={ConfirmPutAwayForm} />
    <Route path="/putaway/printPutaway" component={PrintPutAwayForm} />
    <Route path="/putaway/printtPutaway" component={AllocatePutAway} />

    <Route path="/putaway/uploadgrn" component={UploadGRN} />
    <Route path="/putaway/printDetail" component={PrintDetailForm} />
    
  </Switch>
);
